// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2v3mf","author":"Table_author__q5-vM","authorImage":"Table_authorImage__3rHYI","unreadRow":"Table_unreadRow__P26mx"};